import * as THREE from 'three';

/** Thin cyan / white rail slug — weaker than missiles (needs multi-hit). */
const CORE = 0xe0f7ff;
const GLOW = 0x4dd0e1;
const TIP = 0xffffff;

/**
 * Fast railgun projectile. Local +Z is tip-forward before orientation.
 */
export function createRailBolt(): THREE.Group {
  const bolt = new THREE.Group();
  bolt.name = 'arcade-rail-bolt';

  const coreMat = new THREE.MeshBasicMaterial({ color: CORE });
  const glowMat = new THREE.MeshBasicMaterial({ color: GLOW });
  const tipMat = new THREE.MeshBasicMaterial({ color: TIP });

  const shaft = new THREE.Mesh(new THREE.BoxGeometry(0.12, 0.12, 1.4), coreMat);
  bolt.add(shaft);

  const glow = new THREE.Mesh(new THREE.BoxGeometry(0.2, 0.2, 1.1), glowMat);
  glow.position.z = -0.05;
  bolt.add(glow);

  const tip = new THREE.Mesh(new THREE.BoxGeometry(0.1, 0.1, 0.28), tipMat);
  tip.position.z = 0.78;
  bolt.add(tip);

  // Slightly generous radius so fast bolts still register hits
  bolt.userData.radius = 0.95;
  return bolt;
}
